import React, { useState } from 'react';
import styled from 'styled-components';

function OutlookExpress({ onClose }) {
  const [to, setTo] = useState('hello@deadsimplecomputing.co.uk');
  const [cc, setCc] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  function handleSend(e) {
    if (e) e.preventDefault();
    if (!subject.trim() || !body.trim()) return;
    setSending(true);
    setTimeout(() => {
      const mailtoUrl = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.open(mailtoUrl, '_blank');
      setSent(true);
      setSending(false);
    }, 1500);
  }

  if (sent) {
    return (
      <Div>
        <div className="oe__sent">
          <div className="oe__sent__dialog">
            <div className="oe__sent__dialog__header">Message Sent</div>
            <div className="oe__sent__dialog__body">
              <div className="oe__sent__dialog__icon">i</div>
              <div>
                <p>Your email client should have opened with your message pre-filled.</p>
                <p style={{ marginTop: 10 }}>You can also reach us directly:</p>
                <table className="oe__sent__table">
                  <tbody>
                    <tr>
                      <td className="oe__sent__label">Dead Simple Computing</td>
                      <td>0118 359 2220</td>
                    </tr>
                    <tr>
                      <td />
                      <td className="oe__sent__email">hello@deadsimplecomputing.co.uk</td>
                    </tr>
                    <tr><td colSpan="2" style={{ height: 8 }} /></tr>
                    <tr>
                      <td className="oe__sent__label">Dead Simple Accounting</td>
                      <td>0118 359 3666</td>
                    </tr>
                    <tr>
                      <td />
                      <td className="oe__sent__email">hello@deadsimpleaccounting.co.uk</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="oe__sent__dialog__buttons">
              <button className="oe__xp__btn" onClick={() => { setSent(false); setSubject(''); setBody(''); }}>
                New Message
              </button>
              <button className="oe__xp__btn" onClick={onClose}>Close</button>
            </div>
          </div>
        </div>
      </Div>
    );
  }

  return (
    <Div>
      <div className="oe__menubar">
        <span className="oe__menu">File</span>
        <span className="oe__menu">Edit</span>
        <span className="oe__menu">View</span>
        <span className="oe__menu">Insert</span>
        <span className="oe__menu">Format</span>
        <span className="oe__menu">Tools</span>
        <span className="oe__menu">Message</span>
        <span className="oe__menu">Help</span>
      </div>
      <div className="oe__toolbar">
        <button className="oe__toolbar__btn" onClick={handleSend} disabled={sending}>
          <span className="oe__toolbar__icon__text">Send</span>
        </button>
        <div className="oe__toolbar__sep" />
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Cut</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Copy</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Paste</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Undo</span>
        </button>
        <div className="oe__toolbar__sep" />
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Check</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Spelling</span>
        </button>
        <div className="oe__toolbar__sep" />
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Attach</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Priority</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Sign</span>
        </button>
        <button className="oe__toolbar__btn" disabled>
          <span className="oe__toolbar__icon__text">Encrypt</span>
        </button>
      </div>
      <div className="oe__fields">
        <div className="oe__field">
          <label className="oe__label">To:</label>
          <select className="oe__select" value={to} onChange={e => setTo(e.target.value)}>
            <option value="hello@deadsimplecomputing.co.uk">Dead Simple Computing (hello@deadsimplecomputing.co.uk)</option>
            <option value="hello@deadsimpleaccounting.co.uk">Dead Simple Accounting (hello@deadsimpleaccounting.co.uk)</option>
          </select>
        </div>
        <div className="oe__field">
          <label className="oe__label">Cc:</label>
          <input
            type="text"
            className="oe__input"
            value={cc}
            onChange={e => setCc(e.target.value)}
            placeholder=""
          />
        </div>
        <div className="oe__field">
          <label className="oe__label">Subject:</label>
          <input
            type="text"
            className="oe__input"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            placeholder=""
          />
        </div>
      </div>
      <div className="oe__format__bar">
        <select className="oe__format__font" disabled>
          <option>Arial</option>
        </select>
        <select className="oe__format__size" disabled>
          <option>10</option>
        </select>
        <span className="oe__format__btn" title="Bold">B</span>
        <span className="oe__format__btn oe__format__btn--italic" title="Italic">I</span>
        <span className="oe__format__btn oe__format__btn--underline" title="Underline">U</span>
        <div className="oe__format__sep" />
        <span className="oe__format__btn" title="Align Left">{'\u2261'}</span>
        <span className="oe__format__btn" title="Center">{'\u2261'}</span>
        <span className="oe__format__btn" title="Bullets">{'\u2022'}</span>
      </div>
      <textarea
        className="oe__body"
        value={body}
        onChange={e => setBody(e.target.value)}
        placeholder={'Write your message here...\n\nWe\'d love to hear from you. Whether you need IT support,\ncyber security, Microsoft 365, bookkeeping, or tax returns\n-- we\'re here to help.\n\nDead Simple Computing: 0118 359 2220\nDead Simple Accounting: 0118 359 3666'}
      />
      <div className="oe__statusbar">{sending ? 'Sending message...' : 'Ready'}</div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #ece9d8;
  font-family: Tahoma, sans-serif;
  font-size: 11px;

  .oe__menubar {
    display: flex;
    background: #ece9d8;
    padding: 2px 4px;
    border-bottom: 1px solid #aaa;
  }
  .oe__menu {
    padding: 2px 8px;
    font-size: 11px;
    cursor: default;
    &:hover {
      background: #316ac5;
      color: white;
    }
  }
  .oe__toolbar {
    background: linear-gradient(to bottom, #fafafa, #e4e4e4);
    padding: 2px 4px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #aaa;
    gap: 1px;
    flex-wrap: wrap;
  }
  .oe__toolbar__btn {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px 6px;
    border: 1px solid transparent;
    border-radius: 2px;
    background: none;
    font-family: Tahoma, sans-serif;
    font-size: 10px;
    cursor: pointer;
    &:hover:not(:disabled) {
      border-color: #bbb;
      background: linear-gradient(to bottom, #fff, #e3e3e3);
    }
    &:active:not(:disabled) {background: #ccc;}
    &:disabled {opacity: 0.5; cursor: default;}
  }
  .oe__toolbar__icon__text {
    font-size: 10px;
  }
  .oe__toolbar__sep {
    width: 1px;
    height: 18px;
    background: #bbb;
    margin: 0 3px;
  }
  .oe__fields {
    background: white;
    border-bottom: 1px solid #ccc;
  }
  .oe__field {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    &:last-child { border-bottom: none; }
  }
  .oe__label {
    width: 55px;
    padding: 4px 8px;
    font-weight: bold;
    font-size: 11px;
    color: #333;
    background: #f4f4f4;
    border-right: 1px solid #ddd;
    flex-shrink: 0;
    text-align: right;
  }
  .oe__select, .oe__input {
    flex: 1;
    border: none;
    padding: 4px 8px;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    outline: none;
    background: white;
  }
  .oe__select { cursor: pointer; }
  .oe__format__bar {
    background: linear-gradient(to bottom, #f5f5f0, #e8e8e0);
    padding: 2px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    border-bottom: 1px solid #ccc;
  }
  .oe__format__font {
    font-size: 10px;
    font-family: Tahoma, sans-serif;
    width: 100px;
    height: 18px;
  }
  .oe__format__size {
    font-size: 10px;
    font-family: Tahoma, sans-serif;
    width: 40px;
    height: 18px;
  }
  .oe__format__btn {
    width: 20px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    border: 1px solid transparent;
    cursor: default;
    &:hover { border-color: #bbb; background: #fff; }
  }
  .oe__format__btn--italic { font-style: italic; }
  .oe__format__btn--underline { text-decoration: underline; }
  .oe__format__sep {
    width: 1px;
    height: 14px;
    background: #bbb;
  }
  .oe__body {
    flex: 1;
    border: none;
    padding: 8px;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    line-height: 1.5;
    resize: none;
    outline: none;
  }
  .oe__statusbar {
    background: linear-gradient(to bottom, #e8e8e8, #d4d4d4);
    padding: 2px 8px;
    font-size: 10px;
    border-top: 1px solid #aaa;
    color: #555;
  }

  /* === SENT DIALOG === */
  .oe__sent {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ece9d8;
  }
  .oe__sent__dialog {
    background: #ece9d8;
    border: 2px solid #0054e3;
    box-shadow: 3px 3px 8px rgba(0,0,0,0.3);
    width: 400px;
    max-width: 90%;
  }
  .oe__sent__dialog__header {
    background: linear-gradient(to right, #0054e3, #2e8bff);
    color: white;
    padding: 4px 8px;
    font-weight: bold;
    font-size: 11px;
  }
  .oe__sent__dialog__body {
    padding: 16px;
    display: flex;
    gap: 12px;
    font-size: 11px;
    line-height: 1.5;
    p { margin: 0; }
  }
  .oe__sent__dialog__icon {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #0054e3;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
  }
  .oe__sent__table {
    margin-top: 8px;
    font-size: 10px;
    border-collapse: collapse;
    td { padding: 2px 8px 2px 0; }
  }
  .oe__sent__label { font-weight: bold; color: #003399; }
  .oe__sent__email { color: #666; }
  .oe__sent__dialog__buttons {
    padding: 8px 16px 12px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .oe__xp__btn {
    padding: 4px 18px;
    background: linear-gradient(to bottom, #fff, #e3e3e3);
    border: 1px solid #999;
    border-radius: 2px;
    cursor: pointer;
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    &:hover { background: linear-gradient(to bottom, #e3e3e3, #fff); }
    &:active { background: #ccc; }
  }
`;

export default OutlookExpress;
